import {useEffect, useRef} from "react";
import {isMobile} from "react-device-detect";
import type {UseFormReturn} from "react-hook-form";
import SignatureCanvas from "react-signature-canvas";
import {Button} from "reactstrap";
import z from "zod";

export const step8Schema = z.object({
  signature: z.string().optional(),
});

export type Step8Form = z.infer<typeof step8Schema>;

type Props = {
  hookForm: UseFormReturn<Step8Form>;
  disabled: boolean;
};

export function Step8({hookForm, disabled}: Props) {
  const signatureRef = useRef<SignatureCanvas>(null);
  const width = isMobile ? 300 : 450;

  useEffect(() => {
    if (disabled) {
      signatureRef.current?.off();
    } else {
      signatureRef.current?.on();
    }
  }, [disabled]);

  return (
    <>
      <h5 style={{marginBottom: "16px"}}>Signature du client (facultative)</h5>
      <p style={{marginBottom: "16px"}}>En option</p>
      <div
        style={{
          border: "1px solid #ccc",
          borderRadius: "4px",
          backgroundColor: "#fff",
          marginBottom: "16px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <SignatureCanvas
          ref={signatureRef}
          canvasProps={{
            width,
            height: 200,
            "aria-label": "Signature du client",
            "aria-disabled": disabled,
            className: "signature-canvas",
            style: {
              width: `${width}px`,
              height: "200px",
              pointerEvents: disabled ? "none" : undefined,
            },
          }}
          backgroundColor="white"
          onEnd={handleSignatureEnd}
        />
      </div>
      <div style={{display: "flex", gap: "8px", justifyContent: "flex-end"}}>
        <Button color="secondary" onClick={handleClear} disabled={disabled} size="sm">
          Recommencer
        </Button>
      </div>
    </>
  );

  function handleSignatureEnd() {
    if (signatureRef.current && !disabled) {
      hookForm.setValue(
        "signature",
        signatureRef.current.isEmpty() ? undefined : signatureRef.current.toDataURL()
      );
    }
  }

  function handleClear() {
    if (signatureRef.current && !disabled) {
      signatureRef.current.clear();
      hookForm.setValue("signature", undefined);
    }
  }
}
